/**
 * Audit action identifiers (Phase 1 scope).
 * The audit log answers WHO / WHAT / WHEN / WHICH BRANCH and is append-only.
 * Future phases add transaction, verification, purchasing, inventory actions.
 */
export const AUDIT_ACTIONS = {
  AUTH_LOGIN: 'auth.login',
  AUTH_LOGIN_FAILED: 'auth.login_failed',
  AUTH_LOGOUT: 'auth.logout',
  AUTH_TOKEN_REFRESHED: 'auth.token_refreshed',
  AUTH_REFRESH_REJECTED: 'auth.refresh_rejected',
  USER_CREATED: 'user.created',
  USER_UPDATED: 'user.updated',
  USER_PASSWORD_RESET: 'user.password_reset',
  USER_STATUS_CHANGED: 'user.status_changed',
  // Phase 2A - receiving foundation
  TRANSACTION_CREATED: 'transaction.created',
  // Phase 2B - status workflow
  TRANSACTION_STATUS_CHANGED: 'transaction.status_changed',
  // Phase 2C - processing stages (item accountability)
  TRANSACTION_PROCESSING_STARTED: 'transaction.processing_started',
  TRANSACTION_PROCESSING_COMPLETED: 'transaction.processing_completed',
  // Phase 2D - pick-up & release workflow
  TRANSACTION_RELEASED: 'transaction.released',
  // Phase 2E - inventory
  INVENTORY_ITEM_CREATED: 'inventory.item_created',
  INVENTORY_ITEM_UPDATED: 'inventory.item_updated',
  INVENTORY_STOCK_IN: 'inventory.stock_in',
  INVENTORY_STOCK_OUT: 'inventory.stock_out',
  INVENTORY_ADJUSTED: 'inventory.adjusted',
  // Phase 2E - purchasing
  PURCHASE_CREATED: 'purchase.created',
  PURCHASE_POSTED: 'purchase.posted',
  PURCHASE_CANCELLED: 'purchase.cancelled',
  // Phase 2E - expenses
  EXPENSE_CREATED: 'expense.created',
  EXPENSE_UPDATED: 'expense.updated',
  SERVICE_CREATED: 'service.created',
  SERVICE_UPDATED: 'service.updated',
  // Phase 2G.7 - daily cash reconciliation & handover accountability
  RECONCILIATION_CREATED: 'reconciliation.created',
  RECONCILIATION_UPDATED: 'reconciliation.updated',
  RECONCILIATION_SUBMITTED: 'reconciliation.submitted',
  RECONCILIATION_REVIEWED: 'reconciliation.reviewed',
  // Phase 2G.8 - daily operations & shift handover accountability
  HANDOVER_CREATED: 'handover.created',
  HANDOVER_UPDATED: 'handover.updated',
  HANDOVER_SUBMITTED: 'handover.submitted',
  HANDOVER_ACCEPTED: 'handover.accepted',
  // Phase 2G.9 - operational loss prevention & control review
  CONTROL_REVIEW_OPENED: 'control_review.opened',
  CONTROL_REVIEW_STARTED: 'control_review.started',
  CONTROL_REVIEW_ASSIGNED: 'control_review.assigned',
  CONTROL_REVIEW_NOTE_ADDED: 'control_review.note_added',
  CONTROL_REVIEW_ACTION_REQUESTED: 'control_review.action_requested',
  CONTROL_REVIEW_ACTION_CONTINUED: 'control_review.action_continued',
  CONTROL_REVIEW_RESOLVED: 'control_review.resolved',
  CONTROL_REVIEW_REOPENED: 'control_review.reopened',
  // Phase 2F - delivery
  DELIVERY_STARTED: 'delivery.started',
  DELIVERY_ASSIGNED: 'delivery.assigned',
  DELIVERY_COMPLETED: 'delivery.completed',
  DELIVERY_CLOSED: 'delivery.closed',
} as const;

export type AuditAction = (typeof AUDIT_ACTIONS)[keyof typeof AUDIT_ACTIONS];

/** Entity types recorded in audit_logs.entity_type (Phase 1). */
export const AUDIT_ENTITIES = {
  USER: 'user',
  SESSION: 'session',
  BRANCH: 'branch',
  TRANSACTION: 'transaction',
  SERVICE: 'service',
  // Phase 2E
  INVENTORY_ITEM: 'inventory_item',
  INVENTORY_MOVEMENT: 'inventory_movement',
  PURCHASE: 'purchase',
  EXPENSE: 'expense',
  // Phase 2G.7
  CASH_RECONCILIATION: 'cash_reconciliation',
  // Phase 2G.8
  HANDOVER: 'handover',
  // Phase 2G.9
  CONTROL_REVIEW: 'control_review',
} as const;
